import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const parentWindow = window.parent;

const errorHandler = (error) => {
  if (error.response.status === 403) {
    toast.warning(
      <div>
        <p>Tu sesión ha expirado, refresca la página para poder continuar.</p>
        <button
          onClick={() => {
            parentWindow.postMessage("reload", "*");
          }}
          style={{ padding: ".5em .5em 0 0" }}
        >
          <strong>Refrescar página</strong>
        </button>
      </div>,
      {
        autoClose: false,
        toastId: "sessionExpiredErrorToast",
      }
    );
  } else if (error.response.status === 500) {
    // toast.warning(
    //     <div>
    //       <p>Lo siento, estamos experimentando problemas de conexión interna. Por favor, inténtalo de nuevo o refresca tu navegador.</p>
    //         <button onClick={() => {
    //           parentWindow.postMessage("reload", "*");
    //         }}
    //         style={{padding: ".5em .5em 0 0"}}><strong>Refrescar página</strong></button>
    //     </div>,
    //     {
    //       autoClose: false,
    //       toastId: "otherErrorToast"
    //     }
    //   )
  } else if (
    error.response.status === 400 &&
    error.response.data.detail === "Invalid verification token"
  ) {
    toast.warning(
      <div>
        <p>Tu sesión ha expirado, refresca la página para poder continuar.</p>
        <button
          onClick={() => {
            parentWindow.postMessage("reload", "*");
          }}
          style={{ padding: ".5em .5em 0 0" }}
        >
          <strong>Refrescar página</strong>
        </button>
      </div>,
      {
        autoClose: false,
        toastId: "sessionExpiredErrorToast",
      }
    );
  }
  return Promise.reject({ ...error });
};

// axios instance for making requests
const axiosInstance = axios.create();

// response interceptor for handling common errors (e.g. HTTP 500)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => errorHandler(error)
);

export default axiosInstance;
